import labels from "emun.products/lists/_labels";
import templateUrl from "emun.products/lists/product-list-barcode.htm";
import config from "emun.products/lists/product-list.config";
import basicController from "servicestack/basic.controller.properties";
import ServiceBus from "servicestack/service-bus";
import open from "webmodals/open";
import { spawnUrl } from "webutils/services/util";

export const sortDirections = ["Ascending", "Descending"];
export const sortOptions = ["Product ID", "Description"];
export const labelTypes = [
  "Large Labels (Avery 5160)",
  "Large Labels 2 (Avery 5160)",
  "Small Labels (Avery 5167)",
  "Small Labels 2 (Avery 5167)",
  "Small UPC 1x1",
  "Tiny Barcode",
  "Business Card (Avery 8371)",
];
export const barcodeTypes = ["Code 3 of 9", "UPC"];

export default (options) =>
  open({
    size: options.size || "md",
    templateUrl: options.templateUrl || templateUrl,
    bindToController: true,
    controllerAs: "$ctrl",
    controller() {
      const $ctrl = this;
      basicController($ctrl);
      $ctrl.title = options.title || "Barcode Printout";
      $ctrl.subTitle = options.subTitle;
      $ctrl.bus = new ServiceBus();
      $ctrl.config = config;
      var requestId = (((1 + Math.random()) * 0x10000) | 0)
        .toString(16)
        .substring(1);
      $ctrl.request = Object.assign(
        {
          reportName: "ProductBarcodeReport",
          displayName: "ProductBarcodeReport",
          labelReport: labels.defaultBarcode || "Small UPC 1x1",
          barcodeType: "Code 3 of 9",
          startPositionRow: 0,
          startPositionCol: 0,
          displayImage: config.barcodeLabelImage,
          requestId: requestId,
          //sortOption: "Product ID",
          //sortDirection: "Ascending"
        },
        options.request
      );
      $ctrl.labels = labels;
      $ctrl.sortDirections = sortDirections;
      $ctrl.sortOptions = sortOptions;
      $ctrl.labelTypes = labelTypes;
      $ctrl.barcodeTypes = barcodeTypes;
      $ctrl.getUrl = () => {
        const url = $ctrl.$appConfig.resolveServiceUrl(
          `RunReport?${Object.keys($ctrl.request)
            .map((key) => key + "=" + $ctrl.request[key])
            .join("&")}`
        );
        //console.debug("barcode url", url);
        spawnUrl(url, { target: "_blank" });
        //return url;
      };
    },
  }).result;
